import { useCultureContext } from './useCultureContext';
import { formatCurrency } from '../formatters';
export function useFormatCurrency(value, options) {
  var _useCultureContext = useCultureContext(),
    culture = _useCultureContext.culture;
  return formatCurrency(value, culture, options);
}